var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wabident-treatment-icon",style:(_vm.icon_style)},[_c('i',{staticClass:"wabident",class:_vm.icon_class})])
}
var staticRenderFns = []

export { render, staticRenderFns }